import { CompanySection } from "./CompanySection";
import { LocationSection } from "./LocationSection";
import { Box } from "../../../../../../mads";
import { Text } from "../../../../../../mads/Text";
import { useViewjobProctorAllocation } from "../../../../../proctor/__generated__/ViewjobProctorContext";
import { MobVjJobSummaryTst } from "../../../../../proctor/__generated__/ViewjobProctorSpecifications";
import {
  useIsDesktopDisplay,
  useViewjobOneGraphModel,
} from "../../../../context/ViewJobDataContext";

import { colors } from "@indeed/ifl-tokens";
import React from "react";
import { StyleSheet } from "react-native";

interface RemoteWorkModel {
  text?: string;
  inlineText?: boolean;
}

export type InlineHeaderProps = {
  remoteWorkModel?: RemoteWorkModel;
  isCondensedRating?: boolean;
  hideLocationSection?: boolean;
};

export function InlineHeader({
  remoteWorkModel,
  isCondensedRating,
  hideLocationSection,
}: InlineHeaderProps) {
  return (
    <Box sx={styles.container}>
      <CompanySection />

      {!hideLocationSection && <LocationSection />}

      {!remoteWorkModel?.inlineText && !!remoteWorkModel?.text && (
        <Text sx={[styles.remoteWork, isCondensedRating && styles.remoteWorkCompRating]}>
          {remoteWorkModel.text}
        </Text>
      )}
    </Box>
  );
}

const styles = StyleSheet.create({
  container: { display: "flex", flexDirection: "column", flexShrink: 1 },
  remoteWork: {
    color: colors.neutral[700],
  },
  remoteWorkCompRating: {
    color: colors.neutral[1000],
    fontSize: 18,
  },
});

export interface OGWrappedInlineHeaderProps {}

export function OGWrappedInlineHeader({}: OGWrappedInlineHeaderProps) {
  const ogModel = useViewjobOneGraphModel();
  const isDesktop = useIsDesktopDisplay();
  const { job, features } = ogModel ?? {};
  const mobVjJobSummaryTstActive = useViewjobProctorAllocation(MobVjJobSummaryTst).value > 0;

  if (ogModel == null) {
    return null;
  }
  const remoteWorkModel = job?.remoteWorkModel;
  const isCondensedRating = features?.isCondensedRating;

  return (
    <InlineHeader
      remoteWorkModel={remoteWorkModel}
      isCondensedRating={isCondensedRating}
      hideLocationSection={mobVjJobSummaryTstActive && !isDesktop}
    />
  );
}
